import React from 'react';
import PropTypes from 'prop-types';
import ContactForm from './contact-form';

export default class ContactFormModal extends React.Component {
  static propTypes = {
    hideSubject: PropTypes.bool,
    subject: PropTypes.string,
    message: PropTypes.string,
    title: PropTypes.string,
  };

  static defaultProps = {
    hideSubject: false,
    subject: '',
    message: '',
    title: 'Contact us',
  };

  present() {
    this.$overlay.fadeIn();
    this.$modal.fadeIn();
    this.contactForm.clear();
  }

  dismiss() {
    this.$overlay.fadeOut();
    this.$modal.fadeOut();
  }

  render() {
    return (
      <div>
        <div className="modal-overlay" ref={el => (this.$overlay = $(el))} />
        <div className="modal" tabIndex="-1" role="dialog" ref={el => (this.$modal = $(el))}>
          <article>
            <header>
              <h4>{this.props.title}</h4>
            </header>
            <section>
              <ContactForm
                ref={c => (this.contactForm = c)}
                hideSubject={this.props.hideSubject}
                hideSubmit
                subject={this.props.subject}
                message={this.props.message}
                onAfterSubmit={() => this.dismiss()}
              />
            </section>
            <footer>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => this.dismiss()}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => this.contactForm.submit()}
              >
                Send
              </button>
            </footer>
          </article>
        </div>
      </div>
    );
  }
}
